/**
 * Sale/estimate document display flags from API (SaleSettingResource / EstimateSettingResource).
 * When display_due_date is false, due/expiry should not be shown to customers.
 */
export function isDueDateDisplayed(settings) {
  return settings?.display_due_date !== false;
}
